

































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';

@Component({
  components: {
    Typography
  }
})
export default class ButtonTabs extends Vue {
  @Prop(String) title!: string;
  @Prop({ default: [] }) tabs!: string[];
  @Prop({ default: '' }) activeTab?: string;
  @Prop({ default: '#FFF' }) color?: string;
  @Prop({ default: 'light' }) theme?: string;

  get colorStyle() {
    return {
      color: this.color
    };
  }
}
